export class ModelTypes {
    static shareholders = 'ShareholderModel';
    static shareholdersSummary = 'ShareholderSummaryModel';
    static gmShareholdersSummary = 'GmShareholderSummaryModel';
    static traders = 'TraderModel';
    static tradersSummary = 'TraderSummaryModel';
    static transactions = 'TransactionModel';
    static transactionsSummary = 'TransactionSummaryModel';
    static users = 'UserModel';
    static reports = 'ReportModel';
}
